export default class UserRoleModel {
    constructor(data?: any) {
        if (data) {
            this.id = data.id ?? 0;
            this.name = data.name ?? '';           
        }
    }

    id = 0;
    name = '';
}
